import ProductAdmin from "./ProductAdmin";

export default ProductAdmin;
